<template>
  <div>
    <div :id="'dropzone-' + _uid" class="drop-zone dz-clickable" data-upload-path="/api/admin/crop" data-image-previews="id" :style="dropzoneAreaStyle">
      <div class="dz-message" :style="dropzoneMessageStyle">
        {{ uploadMessage }}
      </div>
    </div>
  </div>
</template>
<style>
  .dz-message {
    text-align: center;
    padding: 50px;
  }
  .drop-zone {
    border: dashed 5px #e6e6e6;
    border-radius: 3px;
    margin-bottom: 10px;
    cursor: pointer;
  }
  .drop-zone:hover {
    background: #C0C0C0;
  }
</style>
<script>
  import event from '../../event.js'
  import Dropzone from 'dropzone'
  import $ from 'jquery'
  export default{
    name: 'ImageCropper',
    data () {
      return {
        myDropzone: null,
        url: '/api/admin/crop',
        cachedFilename: ''
      }
    },
    props: ['parentId', 'index', 'styles', 'uploadMessage'],
    components: {
    },
    computed: {
      dropzoneAreaStyle () {
        return typeof this.styles !== 'undefined' && this.styles.hasOwnProperty('area') ? this.styles.area : {}
      },
      dropzoneMessageStyle () {
        return typeof this.styles !== 'undefined' && this.styles.hasOwnProperty('message') ? this.styles.message : {}
      }
    },
    methods: {
    },
    mounted () {
      this.$nextTick(() => {
        const self = this
        var $dzContainer = self.$el.querySelector('#dropzone-' + self._uid)
        self.myDropzone = new Dropzone(self.$el.querySelector('#dropzone-' + self._uid), {
          url: self.url,
          uploadMultiple: true,
          clickable: true,
          acceptedFiles: 'image/jpeg',
          success: function (file, response) {
            if (file.status === 'success') {
              var $file = $(file.previewElement)
              try {
                event.$emit('doc-uploaded', {
                  parentId: self.parentId,
                  index: self.index,
                  file: response.image
                })
              } catch (e) {
                self.$emit('doc-uploaded', {
                  parentId: self.parentId,
                  index: self.index,
                  file: response.image
                })
              }
              $file.addClass('dz-success').delay(1000).fadeOut(400, function () {
                $file.remove().promise().done(function () {
                  if (!$dzContainer.querySelector('.dz-preview')) {
                    $dzContainer.classList.remove('dz-started')
                  }
                })
              })
            }
          }
        })
        /* self.myDropzone.on('sending', function (file, xhr, formData) {
         formData.append('userName', 'bob')
         }) */
      })
    },
    beforeDestroy () {
      this.myDropzone.destroy()
    }
  }
</script>



// WEBPACK FOOTER //
// DropFile.vue?22c4e430